import React from "react";
import {injectIntl} from "react-intl";
import {isUnifiedOVColumn} from "../../../util/LidarTesterUtil";
import {LIDAR_COLUMN_DIMENSIONS} from "../../../util/Constants";

const COLUMN_LABEL_STYLE = (label) => {
    return {
        width: (label && label.length > 1) || isUnifiedOVColumn (label) ? LIDAR_COLUMN_DIMENSIONS.WIDE_WIDTH : LIDAR_COLUMN_DIMENSIONS.NARROW_WIDTH,
        textAlign: "center"
    }
}

const ColumnLabel = (props) => {

    const {label} = props

    return (
        <div style={COLUMN_LABEL_STYLE(label)}>{label}</div>
    )
}

export default injectIntl(ColumnLabel);


// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/lidarTester/ColumnLabel.js